import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, Router, RouterStateSnapshot } from '@angular/router';
import { SCHEME_LINK_PARAM, SessionService } from '../services/session.service';
import { AllowPageExitService } from '../services/allow-page-exit.service';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs';

export interface CanComponentDeactivate {
  confirm(): boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ViewsGuard {
  constructor(
    private sessionService: SessionService,
    private allowPageExitService: AllowPageExitService,
    private router: Router,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const tokenValid = this.sessionService.tokenValid();

    if (tokenValid) {
      const linkedSchemeId = route.queryParamMap.get(SCHEME_LINK_PARAM);
      return linkedSchemeId ? this.redirectToLinkedScheme(linkedSchemeId, state.url) : true;
    } else {
      sessionStorage.setItem('destination', state.url);

      if (state.url.includes('hmac') && state.url.includes('shop')) {
        let hmac = state.root.queryParams['hmac'];
        let host = state.root.queryParams['host'];
        let shop = state.root.queryParams['shop'];
        let timestamp = state.root.queryParams['timestamp'];

        let redirectUrl = environment.setupAppUrl + '?hmac=' + hmac + '&host=' + host + '&shop=' + shop + '&timestamp=' + timestamp;
        window.location.href = redirectUrl;
      } else {
        this.sessionService.redirectToAuth();
      }

      return false;
    }
  }

  canDeactivate(): Observable<boolean> {
    if (this.allowPageExitService.showConfirmRedirectDialog) {
      this.allowPageExitService.showDialog();
      return this.allowPageExitService.allowRedirect;
    } else {
      return of(true);
    }
  }

  // /load opens the linked scheme before the page renders. The destination drops the param,
  // otherwise later navigations that merge query params would switch back to this scheme.
  private redirectToLinkedScheme(schemeId: string, url: string): RedirectCommand {
    const destination = this.router.parseUrl(url);
    delete destination.queryParams[SCHEME_LINK_PARAM];
    sessionStorage.setItem('destination', this.router.serializeUrl(destination));

    const load = this.router.createUrlTree(['/load'], { queryParams: { [SCHEME_LINK_PARAM]: schemeId } });
    return new RedirectCommand(load, { replaceUrl: true });
  }

}
